export default {
    language: 'en-CA',
    navigation: 'Back',
    home: {
        title: 'Yacht Paint Calculator',
        subtitle:
            'Let us help you choose the best coating system for your boat underwater area and calculate the necessary volume for your needs.',
        findProduct: 'Find product',
        calculateVolume: 'Calculate volume'
    },
    find: {
        questions: {
            type: 'Choose your <strong>boat type</strong>',
            material: "Choose <strong>material</strong> your boat's made of",
            sailFrequency: '<strong>How often</strong> do you use your boat?',
            paintLocation: '<strong>Where</strong> do you paint your boat?',
            waterType: 'In what <strong>type of water</strong> do you use your boat?'
        },
        answers: {
            help: 'I need help chosing antifouling',
            type: [
                {
                    label: 'Sailing boat',
                    icon: 'sailingBoat',
                    value: 'sailing'
                },
                {
                    label: 'Motor boat (slow)',
                    sublabel: 'up to 20 knots',
                    icon: 'motorboatSlow',
                    value: 'motor-slow'
                },
                {
                    label: 'Motor boat (fast)',
                    sublabel: 'faster than 20 knots',
                    icon: 'motorboatFast',
                    value: 'motor-fast'
                }
            ],
            material: [
                {
                    label: 'Fiberglass',
                    value: 'plastic'
                },
                {
                    label: 'Steel',
                    value: 'iron'
                },
                {
                    label: 'Aluminium',
                    value: 'aluminium'
                }
            ],
            sailFrequency: [
                {
                    label: 'Rare',
                    sublabel: '1-2 times a month or less',
                    value: 'low'
                },
                {
                    label: 'Often',
                    sublabel: '1-2 times a week',
                    value: 'medium'
                },
                {
                    label: 'Very often',
                    sublabel: 'Almost every day',
                    value: 'high'
                }
            ],
            paintLocation: [
                {
                    label: 'Choose country',
                    countries: [
                        { label: 'UK', value: 'en-GB' },
                        { label: 'US', value: 'en-US' },
                        { label: 'Canada', value: 'en-CA' },
                        { label: 'Denmark', value: 'da-DK' },
                        { label: 'Spain', value: 'es-ES' },
                        { label: 'Finland', value: 'fi-FI' },
                        { label: 'Germany', value: 'de-DE' },
                        { label: 'Greece', value: 'el-GR' },
                        { label: 'Croatia', value: 'hr-HR' },
                        { label: 'Norway', value: 'nb-NO' },
                        { label: 'Netherlands', value: 'nl-NL' },
                        { label: 'Sweden - East Coast', value: 'sv-SE_e' },
                        { label: 'Sweden - West Coast', value: 'sv-SE_w' },
                        { label: 'Sweden - Lakes', value: 'sv-SE_l' },
                        { label: 'France', value: 'fr-FR' }
                    ]
                }
            ],
            waterType: [
                { label: 'Sea/Ocean', value: 'sea/ocean' },
                { label: 'River', value: 'rivers' },
                { label: 'Lakes', value: 'lakes' }
            ]
        },
        result: {
            heading: 'We recommend',
            selection: {
                title: 'Your selection',
                type: 'Boat type',
                waterType: 'Water type',
                material: 'Material',
                sailFrequency: 'Sailing',
                country: 'Country'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Best buy',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Best buy',
                economicAlternative: 'Biocide-free Economic'
            },
            findOutMore: 'Find out more',
            whereToBuy: 'Where to buy',
            email: 'Email',
            send: 'Send',
            feedback: {
                title: 'Was this information helpful?',
                yes: 'Yes',
                no: 'No',
                comment: 'Comment',
                placeholder: 'Enter your comment here'
            },
            recommendation: {
                title: 'Send recommendation to my email'
            },
            calculateVolume: 'Calculate volume'
        }
    },
    calculate: {
        letsCalculate: "Let's calculate",
        questions: {
            antifouling: 'Choose antifouling',
            keelType: "Choose your boat's <strong>keel type</strong>",
            dimensions: "Enter the <strong>dimensions</strong> of your boat's underwater area"
        },
        answers: {
            keelType: [
                {
                    label: 'Fin keel',
                    icon: 'finKeel',
                    value: 'fin'
                },
                {
                    label: 'Full keel',
                    icon: 'fullKeel',
                    value: 'full'
                }
            ],
            dimensionTitles: [
                {
                    title: 'Individual dimensions'
                },
                {
                    title: 'OR underwater area in m2'
                }
            ],
            dimensions: [
                {
                    type: 'unit',
                    label: 'Unit',
                    values: [{ label: 'Meters', value: 'm' }, { label: 'Feet', value: 'f' }],
                    valuesUS: [{ label: 'Feet', value: 'f' }, { label: 'Meters', value: 'm' }]
                },
                {
                    type: 'waterline',
                    label: 'Length of water line'
                },
                {
                    type: 'beam',
                    label: 'Beam'
                },
                {
                    type: 'draft',
                    label: 'Draft'
                },
                {
                    type: 'm2',
                    label: 'm2'
                }
            ]
        },
        result: {
            heading: 'Required volume',
            // headingTwoCoats: 'Required volume',
            selection: {
                title: 'Your selection',
                antifouling: 'Antifouling',
                type: 'Boat type',
                waterType: 'water Type',
                material: 'Material',
                sailFrequency: 'Activity',
                country: 'Country',
                keelType: 'Keel type',
                dimensions: 'Boat dimensions'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Best buy',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Best buy',
                economicAlternative: 'Biocide-free Economic'
            },
            suggestedAmount: 'Suggested amount',
            suggestedAmountTwoCoats: 'Suggested amount (2 coats)',
            oneCoat: '(1 coat)',
            fiveCoats: '(5 coats)',

            primerAltTiecoatSilic: "Don't forget to always use Tiecoat!",
            primerAltSilicSealSilic:
                '<strong>CASE 2</strong><br/>Application on top of old antifouling in good condition - easy switch to Silic One system',
            primerAlLightSilic:
                '<strong>CASE 1</strong><br/>Removal of old antifouling and application of full system & new boat without expoxy',

            primerAltTiecoat:
                '<strong>CASE 2: Step 2</strong></br>... and then a layer of Conversion Primer.',
            primerAltSilicSeal:
                '<strong>CASE 2: Step 1</strong><br/>For boats without antifouling first apply a layer of Light Primer... (move right to see step 2)',
            primerAlLight:
                '<strong>CASE 1</strong><br/>Application on top of old antifouling in good condition',
            primer:
                '<strong>Body</strong> of the boat is <strong>heavily damaged</strong> or you <strong>paint for the first time?</strong> Maybe you will need...',
            whereToBuy: 'Where to buy',
            email: 'Email',
            send: 'Send',
            or: 'OR',
            feedback: {
                title: 'Was this information helpful?',
                yes: 'Yes',
                no: 'No',
                comment: 'Comment',
                placeholder: 'Enter your comment here'
            },
            recommendation: {
                title: 'Send recommendation to my email'
            },
            calculateVolume: 'Calculate volume'
        }
    },
    map: {
        country: 'Country',
        city: 'City',
        getDirections: 'Get directions',
        placeholder: 'All cities...'
    },
    footer: 'Hempel Yacht - Everything you need to know about yacht painting.'
}
